import { FC } from 'react';
import { ListCheckCompareGrid, ListCheckCompareSide, TextCompareRef } from '../../styles';
import { BYTE_CODE_MAX_CHARS } from '../XrayPanel/XrayPanel';
import { listCheckCopy } from './listCheckCopy';
import { messageOf, TextSide } from './TextPropertiesCompare';

interface BytecodeCompareProps {
  document: TextSide;
  candidate: TextSide;
}

const Side: FC<{ side: TextSide; testId: string }> = ({ side, testId }) => {
  const byteCode = side.status === 'success' ? side.data?.byte_code ?? '' : '';
  const message = messageOf(side, byteCode.length === 0, listCheckCopy.noBytecode);
  return (
    <ListCheckCompareSide data-testid={testId}>
      <h4>
        {side.title}
        {side.aside && <TextCompareRef>{side.aside}</TextCompareRef>}
      </h4>
      {message ? (
        <p>{message}</p>
      ) : (
        <>
          {byteCode.length > BYTE_CODE_MAX_CHARS && (
            <p>{listCheckCopy.bytecodeTruncated(BYTE_CODE_MAX_CHARS, byteCode.length)}</p>
          )}
          <pre role="region" aria-label={side.title} tabIndex={0}>
            {byteCode.slice(0, BYTE_CODE_MAX_CHARS)}
          </pre>
        </>
      )}
    </ListCheckCompareSide>
  );
};

const BytecodeCompare: FC<BytecodeCompareProps> = ({ document, candidate }) => (
  <ListCheckCompareGrid data-testid="bytecode-compare">
    <Side side={document} testId="bytecode-compare-document" />
    <Side side={candidate} testId="bytecode-compare-candidate" />
  </ListCheckCompareGrid>
);

export default BytecodeCompare;
